module.exports = global["jQuery"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/imports-loader/index.js?this=>window!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./jquery.1.11.1.min.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?jQuery!../node_modules/imports-loader?this=>window!../legacy/src/js/vendor/jquery.1.11.1.min.js
// module id = 271
// module chunks = 0